import {FileUpload} from '@/components/atoms'

const CustomFileUploadController = props => {
  /**
   * @typedef {Object} Props
   * @property {function} handleChange - Function to handle changes in the file upload.
   * @property {string} label - Label for the file upload input.
   * @property {Object} data - Data related to the file upload.
   * @property {string} path - Path where the file will be uploaded.
   * @property {Object} errors - Errors related to the file upload.
   * @property {Object} schema - Schema for the file upload.
   * @property {Object} uischema - UI schema for the file upload.
   * @property {boolean} required - Indicates if the file upload is required.
   */
  const {handleChange, label, data, path, errors, schema, uischema, required} = props
  return (
    <FileUpload
      value={data}
      label={label}
      updateValue={newVal => handleChange(path, newVal)}
      errors={errors}
      schema={schema}
      uiSchema={uischema}
      required={required}
    />
  )
}

export default CustomFileUploadController
